<div class="page-body">
    <div>
      <header
      [breadcrumbPath]="breadcrumb"
      ></header>
      <div class="page-content" >
        <h2><tra slug="title_sample_questions"></tra></h2>
        <markdown 
          class="markdown" 
          [data]="lang.tra('page_pre_sample_q_main')" 
          ngPreserveWhitespaces
        ></markdown>
        <div class="radio-group">
          <div>
            <label>
              <input type="radio" value="en" [formControl]="selectedLanguage">
              <span>English</span>
            </label>
          </div>
          <div>
            <label>
              <input type="radio" value="fr" [formControl]="selectedLanguage">
              <span>Français</span>
            </label>
          </div>
        </div>
        <markdown 
          class="markdown" 
          [data]="lang.tra('page_pre_sample_q_instr_continue')" 
          ngPreserveWhitespaces
        ></markdown>
        <div class="practive-button-container">
          <a 
            class="button is-large" 
            routerLink="/{{selectedLanguage.value}}/sample-questions/1"
          ><tra slug="page_pre_sample_q_btn_open_1"></tra></a>
          <a 
            *ngIf="isSecondPracticeTestEnabled"
            class="button is-large" 
            routerLink="/{{selectedLanguage.value}}/sample-questions/2"
          ><tra slug="page_pre_sample_q_btn_open_2"></tra></a>
          
        </div>
      </div>
    </div>
    <footer [hasLinks]="true"></footer>
  </div>
  
  